export function GreenTickIcon() {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="60" cy="60" r="60" fill="#32CD32" fillOpacity="0.1" />
      <path
        d="M54.75 66.75L46.6875 58.6875C46 58 45.125 57.6562 44.0625 57.6562C43 57.6562 42.125 58 41.4375 58.6875C40.75 59.375 40.4062 60.25 40.4062 61.3125C40.4062 62.375 40.75 63.25 41.4375 63.9375L52.125 74.625C52.875 75.375 53.75 75.75 54.75 75.75C55.75 75.75 56.625 75.375 57.375 74.625L78.5625 53.4375C79.25 52.75 79.5938 51.875 79.5938 50.8125C79.5938 49.75 79.25 48.875 78.5625 48.1875C77.875 47.5 77 47.1562 75.9375 47.1562C74.875 47.1562 74 47.5 73.3125 48.1875L54.75 66.75ZM60 97.5C54.8125 97.5 49.9375 96.5156 45.375 94.5469C40.8125 92.5781 36.8438 89.9062 33.4688 86.5312C30.0938 83.1562 27.4219 79.1875 25.4531 74.625C23.4844 70.0625 22.5 65.1875 22.5 60C22.5 54.8125 23.4844 49.9375 25.4531 45.375C27.4219 40.8125 30.0938 36.8438 33.4688 33.4688C36.8438 30.0938 40.8125 27.4219 45.375 25.4531C49.9375 23.4844 54.8125 22.5 60 22.5C65.1875 22.5 70.0625 23.4844 74.625 25.4531C79.1875 27.4219 83.1562 30.0938 86.5312 33.4688C89.9062 36.8438 92.5781 40.8125 94.5469 45.375C96.5156 49.9375 97.5 54.8125 97.5 60C97.5 65.1875 96.5156 70.0625 94.5469 74.625C92.5781 79.1875 89.9062 83.1562 86.5312 86.5312C83.1562 89.9062 79.1875 92.5781 74.625 94.5469C70.0625 96.5156 65.1875 97.5 60 97.5Z"
        fill="#00A177"
      />
    </svg>
  );
}
